// import React, { useState, useEffect } from 'react';
// import { 
//   collection, 
//   getDocs, 
//   query, 
//   orderBy, 
//   addDoc, 
//   updateDoc, 
//   doc, 
//   serverTimestamp,
//   increment 
// } from 'firebase/firestore';
// import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
// import { db, storage } from '../../firebase/firebaseConfig'; // Adjust the import path as necessary
// import './ProjectShowcase.css';

// export default function ProjectShowcase() {
//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showForm, setShowForm] = useState(false);
//   const [formData, setFormData] = useState({
//     title: '',
//     creator: '',
//     description: '',
//     image: null
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [submitError, setSubmitError] = useState('');
//   const [submitSuccess, setSubmitSuccess] = useState(false);
//   const [likeInProgress, setLikeInProgress] = useState({});

//   // Fetch projects from Firestore
//   useEffect(() => {
//     const fetchProjects = async () => {
//       try {
//         setLoading(true);
//         const projectsQuery = query(
//           collection(db, 'projects'),
//           orderBy('createdAt', 'desc')
//         );
//         const querySnapshot = await getDocs(projectsQuery);
        
//         const projectsList = querySnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data()
//         }));
        
//         // If no data in Firestore yet, use local data
//         if (projectsList.length === 0) {
//           setProjects(localProjectsData);
//         } else {
//           setProjects(projectsList);
//         }
//       } catch (error) {
//         console.error("Error fetching projects:", error);
//         // Fallback to local data if Firestore fetch fails
//         setProjects(localProjectsData);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProjects();
//   }, []);

//   // Local projects data as fallback
//   const localProjectsData = [
//     {
//       id: 1,
//       title: 'Smart Home Automation System',
//       creator: 'Rajesh Kumar',
//       description: 'A complete IoT-based home automation system built with ESP32 and custom PCBs for controlling lights, fans, and appliances.',
//       imageUrl: 'https://cdn.pixabay.com/photo/2017/08/01/09/07/mobile-2563782_1280.jpg',
//       likes: 248,
//       createdAt: new Date('2025-05-10').getTime()
//     },
//     {
//       id: 2,
//       title: 'Automated Plant Watering System',
//       creator: 'Priya Sharma',
//       description: 'Solar-powered plant monitoring and watering system with moisture sensors and 3D printed components.',
//       imageUrl: 'https://techatronic.com/wp-content/uploads/2020/12/IMG_20210107_090956_578-1024x768.jpg',
//       likes: 176,
//       createdAt: new Date('2025-05-15').getTime()
//     },
//     {
//       id: 3,
//       title: 'Drone Delivery Prototype',
//       creator: 'Vikram Singh',
//       description: 'Custom-built delivery drone with obstacle avoidance and precision landing capabilities, featuring laser-cut chassis.',
//       imageUrl: 'https://bsmedia.business-standard.com/_media/bs/img/article/2019-01/16/full/1547585100-3103.jpg',
//       likes: 315,
//       createdAt: new Date('2025-05-20').getTime()
//     },
//     {
//       id: 4,
//       title: 'Wearable Health Monitor',
//       creator: 'Ananya Patel',
//       description: 'A compact wearable device that monitors heart rate, blood oxygen, and temperature with real-time smartphone alerts.',
//       imageUrl: 'https://terrabellaseniorliving.com/wp-content/uploads/2022/03/close-up-of-hands-with-smart-phone-and-watch.jpg',
//       likes: 289,
//       createdAt: new Date('2025-05-25').getTime()
//     },
//     {
//       id: 5,
//       title: 'Solar-Powered IoT Weather Station',
//       creator: 'Arjun Reddy',
//       description: 'Self-sustaining weather monitoring system with custom PCB design, 3D printed enclosure, and cloud connectivity.',
//       imageUrl: 'https://iotdesignpro.com/sites/default/files/inline-images/IoT-Weather-Station.jpg',
//       likes: 204,
//       createdAt: new Date('2025-06-01').getTime()
//     }
//   ];

//   // Handle form input changes
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   // Handle image upload
//   const handleImageChange = (e) => {
//     if (e.target.files[0]) {
//       setFormData({ ...formData, image: e.target.files[0] });
//     }
//   };

//   // Reset form
//   const resetForm = () => {
//     setFormData({
//       title: '',
//       creator: '',
//       description: '',
//       image: null
//     });
//     document.getElementById('project-image-upload').value = '';
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     // Validate form
//     if (!formData.title || !formData.creator || !formData.description || !formData.image) {
//       setSubmitError('Please fill all fields and upload an image');
//       return;
//     }
    
//     setSubmitting(true);
//     setSubmitError('');
    
//     try {
//       // Upload image to Firebase Storage
//       const imageRef = ref(storage, `project-images/${Date.now()}_${formData.image.name}`);
//       await uploadBytes(imageRef, formData.image);
//       const imageUrl = await getDownloadURL(imageRef);
      
//       // Add project to Firestore
//       const newProject = {
//         title: formData.title,
//         creator: formData.creator,
//         description: formData.description,
//         imageUrl: imageUrl,
//         likes: 0,
//         createdAt: serverTimestamp()
//       };
      
//       const docRef = await addDoc(collection(db, 'projects'), newProject);
      
//       // Add new project to state
//       setProjects([{
//         id: docRef.id,
//         ...newProject,
//         createdAt: new Date().getTime() // Client-side timestamp for immediate display
//       }, ...projects]);
      
//       // Show success message
//       setSubmitSuccess(true);
//       resetForm();
      
//       // Hide form after 2 seconds
//       setTimeout(() => {
//         setShowForm(false);
//         setSubmitSuccess(false);
//       }, 2000);
      
//     } catch (error) {
//       console.error("Error adding project:", error);
//       setSubmitError('Failed to submit project. Please try again.');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // Handle like button click
//   const handleLike = async (projectId) => {
//     // Prevent multiple clicks
//     if (likeInProgress[projectId]) return;
    
//     setLikeInProgress(prev => ({ ...prev, [projectId]: true }));
    
//     // Optimistically update UI
//     setProjects(prevProjects => 
//       prevProjects.map(project => 
//         project.id === projectId 
//           ? { ...project, likes: project.likes + 1 } 
//           : project
//       )
//     );
    
//     // Update in Firestore
//     try {
//       const projectRef = doc(db, 'projects', projectId.toString());
//       await updateDoc(projectRef, {
//         likes: increment(1)
//       });
//     } catch (error) {
//       console.error("Error updating likes:", error);
//       // Revert optimistic update if error
//       setProjects(prevProjects => 
//         prevProjects.map(project => 
//           project.id === projectId 
//             ? { ...project, likes: project.likes - 1 } 
//             : project
//         )
//       );
//     } finally {
//       setLikeInProgress(prev => ({ ...prev, [projectId]: false }));
//     }
//   };

//   // View project details
//   const viewProjectDetails = (projectId) => {
//     // This would typically navigate to a detail page
//     console.log("View project details for:", projectId);
//     alert(`Viewing details for project: ${projectId}`);
//     // You could implement navigation: navigate(`/projects/${projectId}`);
//   };

//   if (loading) {
//     return (
//       <div className="projects-container1">
//         <h2 className="section-title1">Project Showcase</h2>
//         <div className="loading-indicator1">
//           <div className="spinner1"></div>
//           <p>Loading projects...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="projects-container1">
//       <h2 className="section-title1">Project Showcase</h2>
//       <p className="section-subtitle1">Share your innovative projects with the community</p>

//       {/* Share Project Button */}
//       {!showForm && (
//         <div className="share-project-cta1">
//           <button className="share-button1" onClick={() => setShowForm(true)}>
//             <span className="share-icon1">➕</span> Share Your Project
//           </button>
//         </div>
//       )}

//       {/* Project Submission Form */}
//       {showForm && (
//         <div className="project-form-container1">
//           <h3 className="form-title1">Share Your Project</h3>
//           {submitSuccess && (
//             <div className="submit-success1">
//               Project submitted successfully!
//             </div>
//           )}
//           {submitError && (
//             <div className="submit-error1">
//               {submitError}
//             </div>
//           )}
//           <form className="project-form1" onSubmit={handleSubmit}>
//             <div className="form-group1">
//               <label htmlFor="project-title">Project Title</label>
//               <input
//                 type="text"
//                 id="project-title"
//                 name="title"
//                 value={formData.title}
//                 onChange={handleInputChange}
//                 placeholder="Enter your project title"
//                 required />
//             </div>

//             <div className="form-group1">
//               <label htmlFor="project-creator">Your Name</label>
//               <input
//                 type="text"
//                 id="project-creator"
//                 name="creator"
//                 value={formData.creator}
//                 onChange={handleInputChange}
//                 placeholder="Enter your name"
//                 required />
//             </div>

//             <div className="form-group1">
//               <label htmlFor="project-description">Project Description</label>
//               <textarea
//                 id="project-description"
//                 name="description"
//                 value={formData.description}
//                 onChange={handleInputChange}
//                 placeholder="Describe your project (materials, techniques, purpose, etc.)"
//                 rows={4}
//                 required />
//             </div>

//             <div className="form-group1">
//               <label htmlFor="project-image-upload">Project Image</label>
//               <input
//                 type="file"
//                 id="project-image-upload"
//                 accept="image/*"
//                 onChange={handleImageChange}
//                 required />
//               <small className="upload-help1">Upload a clear image of your project (max 5MB)</small>
//             </div>

//             <div className="form-actions1">
//               <button
//                 type="button"
//                 className="cancel-button1"
//                 onClick={() => setShowForm(false)}
//                 disabled={submitting}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 className="submit-button1"
//                 disabled={submitting}
//               >
//                 {submitting ? 'Submitting...' : 'Submit Project'}
//               </button>
//             </div>
//           </form>
//         </div>
//       )}

//       {/* Projects Grid */}
//       <div className="projects-grid1">
//         {projects.map((project) => (
//           <div key={project.id} className="project-card1">
//             <div className="project-image-container1">
//               <img
//                 src={project.imageUrl}
//                 alt={project.title}
//                 className="project-img1" />
//             </div>
//             <div className="project-content1">
//               <h3 className="project-title1">{project.title}</h3>
//               <div className="project-creator1">
//                 <span className="creator-avatar1">
//                   {project.creator.charAt(0)}
//                 </span>
//                 <span className="creator-name1">{project.creator}</span>
//               </div>
//               <p className="project-description1">{project.description}</p>
//               <div className="project-stats1">
//                 <div className="project-likes1">
//                   <span className="stat-icon1">❤️</span> {project.likes}
//                 </div>
//               </div>
//               <div className="project-actions1">
               
//                 <button
//                   className={`view-project-btn1 ${likeInProgress[project.id] ? 'liking' : ''}`}
//                   onClick={() => handleLike(project.id)}
//                   disabled={likeInProgress[project.id]}
//                 >
//                   {likeInProgress[project.id] ? 'Liking...' : 'Like'}
//                 </button>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
      
//       {/* Empty state when no projects */}
//       {projects.length === 0 && (
//         <div className="no-projects1">
//           <p>No projects have been shared yet. Be the first to share your project!</p>
//         </div>
//       )}
//     </div>
//   );
// }






import React, { useState, useEffect } from 'react';
import { 
  collection, 
  getDocs, 
  query, 
  orderBy, 
  addDoc, 
  updateDoc, 
  doc, 
  serverTimestamp,
  increment 
} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../../firebase/firebaseConfig'; // Adjust the import path as necessary
import './ProjectShowcase.css';

export default function ProjectShowcase() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    creator: '',
    description: '',
    image: null
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [likeInProgress, setLikeInProgress] = useState({});

  // Fetch projects from Firestore
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setLoading(true);
        const projectsQuery = query(
          collection(db, 'projects'),
          orderBy('createdAt', 'desc')
        );
        const querySnapshot = await getDocs(projectsQuery);
        
        const projectsList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        // If no data in Firestore yet, use local data
        if (projectsList.length === 0) {
          setProjects(localProjectsData);
        } else {
          setProjects(projectsList);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
        // Fallback to local data if Firestore fetch fails
        setProjects(localProjectsData);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  // Local projects data as fallback
  const localProjectsData = [
    {
      id: 1,
      title: 'Smart Home Automation System',
      creator: 'Rajesh Kumar',
      description: 'A complete IoT-based home automation system built with ESP32 and custom PCBs for controlling lights, fans, and appliances.',
      imageUrl: 'https://cdn.pixabay.com/photo/2017/08/01/09/07/mobile-2563782_1280.jpg',
      likes: 248,
      createdAt: new Date('2025-05-10').getTime()
    },
    {
      id: 2,
      title: 'Automated Plant Watering System',
      creator: 'Priya Sharma',
      description: 'Solar-powered plant monitoring and watering system with moisture sensors and 3D printed components.',
      imageUrl: 'https://techatronic.com/wp-content/uploads/2020/12/IMG_20210107_090956_578-1024x768.jpg',
      likes: 176,
      createdAt: new Date('2025-05-15').getTime()
    },
    {
      id: 3,
      title: 'Drone Delivery Prototype',
      creator: 'Vikram Singh',
      description: 'Custom-built delivery drone with obstacle avoidance and precision landing capabilities, featuring laser-cut chassis.',
      imageUrl: 'https://bsmedia.business-standard.com/_media/bs/img/article/2019-01/16/full/1547585100-3103.jpg',
      likes: 315,
      createdAt: new Date('2025-05-20').getTime()
    },
    {
      id: 4,
      title: 'Wearable Health Monitor',
      creator: 'Ananya Patel',
      description: 'A compact wearable device that monitors heart rate, blood oxygen, and temperature with real-time smartphone alerts.',
      imageUrl: 'https://terrabellaseniorliving.com/wp-content/uploads/2022/03/close-up-of-hands-with-smart-phone-and-watch.jpg',
      likes: 289,
      createdAt: new Date('2025-05-25').getTime()
    },
    {
      id: 5,
      title: 'Solar-Powered IoT Weather Station',
      creator: 'Arjun Reddy',
      description: 'Self-sustaining weather monitoring system with custom PCB design, 3D printed enclosure, and cloud connectivity.',
      imageUrl: 'https://iotdesignpro.com/sites/default/files/inline-images/IoT-Weather-Station.jpg',
      likes: 204,
      createdAt: new Date('2025-06-01').getTime()
    }
  ];

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle image upload
  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setFormData({ ...formData, image: e.target.files[0] });
    }
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      title: '',
      creator: '',
      description: '',
      image: null
    });
    document.getElementById('project-image-upload').value = '';
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.title || !formData.creator || !formData.description || !formData.image) {
      setSubmitError('Please fill all fields and upload an image');
      return;
    }
    
    setSubmitting(true);
    setSubmitError('');
    
    try {
      // Upload image to Firebase Storage
      const imageRef = ref(storage, `project-images/${Date.now()}_${formData.image.name}`);
      await uploadBytes(imageRef, formData.image);
      const imageUrl = await getDownloadURL(imageRef);
      
      // Add project to Firestore
      const newProject = {
        title: formData.title,
        creator: formData.creator,
        description: formData.description,
        imageUrl: imageUrl,
        likes: 0,
        createdAt: serverTimestamp()
      };
      
      const docRef = await addDoc(collection(db, 'projects'), newProject);
      
      // Add new project to state
      setProjects([{
        id: docRef.id,
        ...newProject,
        createdAt: new Date().getTime() // Client-side timestamp for immediate display
      }, ...projects]);
      
      // Show success message
      setSubmitSuccess(true);
      resetForm();
      
      // Hide form after 2 seconds
      setTimeout(() => {
        setShowForm(false);
        setSubmitSuccess(false);
      }, 2000);
      
    } catch (error) {
      console.error("Error adding project:", error);
      setSubmitError('Failed to submit project. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  // Handle like button click
  const handleLike = async (projectId) => {
    // Prevent multiple clicks
    if (likeInProgress[projectId]) return;
    
    setLikeInProgress(prev => ({ ...prev, [projectId]: true }));
    
    // Optimistically update UI
    setProjects(prevProjects => 
      prevProjects.map(project => 
        project.id === projectId 
          ? { ...project, likes: project.likes + 1 } 
          : project
      )
    );
    
    // Check if this is a local project (numeric ID) or Firestore project (string ID)
    const isLocalProject = typeof projectId === 'number';
    
    if (!isLocalProject) {
      // Only update Firestore for non-local projects
      try {
        const projectRef = doc(db, 'projects', projectId);
        await updateDoc(projectRef, {
          likes: increment(1)
        });
      } catch (error) {
        console.error("Error updating likes:", error);
        // Revert optimistic update if error
        setProjects(prevProjects => 
          prevProjects.map(project => 
            project.id === projectId 
              ? { ...project, likes: project.likes - 1 } 
              : project
          )
        );
      }
    }
    
    // Always mark the like operation as complete
    setTimeout(() => {
      setLikeInProgress(prev => ({ ...prev, [projectId]: false }));
    }, 500); // Add a small delay for better UX
  };

  // View project details
  const viewProjectDetails = (projectId) => {
    // This would typically navigate to a detail page
    console.log("View project details for:", projectId);
    alert(`Viewing details for project: ${projectId}`);
    // You could implement navigation: navigate(`/projects/${projectId}`);
  };

  if (loading) {
    return (
      <div className="projects-container1">
        <h2 className="section-title1">Project Showcase</h2>
        <div className="loading-indicator1">
          <div className="spinner1"></div>
          <p>Loading projects...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="projects-container1">
      <h2 className="section-title1">Project Showcase</h2>
      <p className="section-subtitle1">Share your innovative projects with the community</p>

      {/* Share Project Button */}
      {!showForm && (
        <div className="share-project-cta1">
          <button className="share-button1" onClick={() => setShowForm(true)}>
            <span className="share-icon1">➕</span> Share Your Project
          </button>
        </div>
      )}

      {/* Project Submission Form */}
      {showForm && (
        <div className="project-form-container1">
          <h3 className="form-title1">Share Your Project</h3>
          {submitSuccess && (
            <div className="submit-success1">
              Project submitted successfully!
            </div>
          )}
          {submitError && (
            <div className="submit-error1">
              {submitError}
            </div>
          )}
          <form className="project-form1" onSubmit={handleSubmit}>
            <div className="form-group1">
              <label htmlFor="project-title">Project Title</label>
              <input
                type="text"
                id="project-title"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                placeholder="Enter your project title"
                required />
            </div>

            <div className="form-group1">
              <label htmlFor="project-creator">Your Name</label>
              <input
                type="text"
                id="project-creator"
                name="creator"
                value={formData.creator}
                onChange={handleInputChange}
                placeholder="Enter your name"
                required />
            </div>

            <div className="form-group1">
              <label htmlFor="project-description">Project Description</label>
              <textarea
                id="project-description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                placeholder="Describe your project (materials, techniques, purpose, etc.)"
                rows={4}
                required />
            </div>

            <div className="form-group1">
              <label htmlFor="project-image-upload">Project Image</label>
              <input
                type="file"
                id="project-image-upload"
                accept="image/*"
                onChange={handleImageChange}
                required />
              <small className="upload-help1">Upload a clear image of your project (max 5MB)</small>
            </div>

            <div className="form-actions1">
              <button
                type="button"
                className="cancel-button1"
                onClick={() => setShowForm(false)}
                disabled={submitting}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="submit-button1"
                disabled={submitting}
              >
                {submitting ? 'Submitting...' : 'Submit Project'}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Projects Grid */}
      <div className="projects-grid1">
        {projects.map((project) => (
          <div key={project.id} className="project-card1">
            <div className="project-image-container1">
              <img
                src={project.imageUrl}
                alt={project.title}
                className="project-img1" />
            </div>
            <div className="project-content1">
              <h3 className="project-title1">{project.title}</h3>
              <div className="project-creator1">
                <span className="creator-avatar1">
                  {project.creator.charAt(0)}
                </span>
                <span className="creator-name1">{project.creator}</span>
              </div>
              <p className="project-description1">{project.description}</p>
              <div className="project-stats1">
                <div className="project-likes1">
                  <span className="stat-icon1">❤️</span> {project.likes}
                </div>
              </div>
              <div className="project-actions1">
              
                <button
                  className={`view-project-btn1 ${likeInProgress[project.id] ? 'liking' : ''}`}
                  onClick={() => handleLike(project.id)}
                  disabled={likeInProgress[project.id]}
                >
                  {likeInProgress[project.id] ? 'Liking...' : 'Like'}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Empty state when no projects */}
      {projects.length === 0 && (
        <div className="no-projects1">
          <p>No projects have been shared yet. Be the first to share your project!</p>
        </div>
      )}
    </div>
  );
}